<template>
  <div>
    <field-label :field="field"></field-label>
    <v-select
      :value="value"
      :items="fonts"
      :menu-props="{ zIndex: 1000 }"
      :rules="rules"
      :disabled="field.disabled"
      @change="input"
      dense
      outlined
    ></v-select>
  </div>
</template>

<script>
import FieldLabel from '@/components/editor/partials/FieldLabel'

export default {
  name: 'GoogleFontsField',
  props: ['value', 'field'],
  components: {
    FieldLabel
  },
  data: () => ({
    fonts: [
      {
        value: 'inherit',
        text: 'Default'
      },
      {
        value: 'PT Sans Caption',
        text: 'PT Sans Caption'
      },
      {
        value: 'Space Mono',
        text: 'Space Mono'
      },
      {
        value: 'Comfortaa',
        text: 'Comfortaa'
      },
      {
        value: 'Open Sans',
        text: 'Open Sans'
      }
    ]
  }),
  computed: {
    rules() {
      let rules = this.field.rules || []

      return rules.map(rule => this.$store.state.editor.validation.rules[rule])
    }
  },
  methods: {
    input(value) {
      this.$emit('update:value', value)
    },
    setDefaultValue() {
      // TODO - fix default value set up
      // if (this.value === undefined && this.field.default !== undefined) {
      //   this.input(this.field.default)
      // }
    }
  },
  mounted() {
    this.setDefaultValue()
  }
}
</script>
